import { camelCase, startCase } from 'lodash'

export default (str: string) => startCase(camelCase(str)).replace(/ /g, '')
